import { combineReducers } from 'redux';
import adminAuthReducer from './adminAuthReducer';
import dataReducer from './dataReducer';
import clientReducer from './clientReducer';
import partnerReducer from './partnerReducer';
import emailManagementReducer from './emailManagementReducer';
import smsManagementReducer from './smsManagementReducer';
import mailingListReducer from './mailingListReducer';
import activitiesReducer from './activitiesReducer';
import claimsReducer from './claimsReducer';
import policiesReducer from './policiesReducer';
import forecastsReducer from './forecastsReducer';
import tripsReducer from './tripsReducer';

const rootReducer = combineReducers({
    adminAuth: adminAuthReducer,
    data: dataReducer,
    clients: clientReducer,
    partners: partnerReducer,
    emailManagement: emailManagementReducer,
    smsManagement: smsManagementReducer,
    mailingList: mailingListReducer,
    activities: activitiesReducer,
    claims: claimsReducer,
    policies: policiesReducer,
    forecasts: forecastsReducer,
    trips: tripsReducer,
});

export default rootReducer;

